import { render } from "./FeedbackBubble.vue?vue&type=template&id=5c0fb0e9&scoped=true"
import script from "./FeedbackBubble.vue?vue&type=script&lang=js"
export * from "./FeedbackBubble.vue?vue&type=script&lang=js"

import "./FeedbackBubble.vue?vue&type=style&index=0&id=5c0fb0e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0fb0e9"]])

export default __exports__